import { IReferenceCode } from "@/lib/interfaces and Enums/ENUMReferenceList";

// LQC-2925 - merge a mirrored list with the API's. The mirror keeps its "most used first"
// order and is all a ticket needs until the API answers, so nothing waits on the network.

const normalise = (value: string) => value.trim().toLowerCase();

// Case-insensitive, as the API's validators are ("Modified following" = "Modified Following").
export function returnValidatedOptions(
  local: string[],
  api: IReferenceCode[] | null,
  appendExtras = true,
): string[] {
  if (!api || api.length === 0) return local;
  const accepted = new Set(api.map((item) => normalise(item.code)));
  const kept = local.filter((option) => accepted.has(normalise(option)));

  if (!appendExtras) return kept;
  const seen = new Set(kept.map(normalise));
  const extras: string[] = [];
  for (const { code } of api) {
    if (seen.has(normalise(code))) continue;
    seen.add(normalise(code));
    extras.push(code);
  }
  return [...kept, ...extras];
}

// "GBLO - London". Code alone when the name adds nothing.
export function returnReferenceCodeLabel(item: IReferenceCode): string {
  if (!item.name || item.name === item.code) return item.code;
  return `${item.code} - ${item.name}`;
}
